/**
 * Bombas de cada arma (comum e especial), de `backend/src/Match/Match.Api/data/weapon-balls.v1.json`. O cliente só usa para baixar a arte e a máscara da cratera
 * antes do primeiro tiro; quem decide a bomba de verdade é o servidor (`ShotResolved.ball_id`). Arma fora da tabela não pré-carrega nada.
 */
const WEAPON_BALLS: Readonly<Record<number, readonly [common: number, special: number]>> = {
  7001: [20, 21],
  7002: [18, 19],
  7003: [22, 23],
  7005: [30, 31],
  7006: [161, 171],
  7007: [101, 111],
  7008: [121, 131],
  7009: [141, 151],
  7010: [381, 391],
  7011: [401, 411],
  7012: [341, 351],
  7013: [361, 371],
  7014: [321, 331],
  7015: [161, 171],
  7016: [101, 111],
  7017: [121, 131],
  7018: [141, 151],
  7019: [381, 391],
  7020: [401, 411],
  7021: [341, 351],
  7022: [361, 371],
  7023: [321, 331],
  7024: [461, 471],
  7025: [42, 43],
  7026: [481, 491],
  7027: [661, 671],
  7028: [701, 711],
  7031: [221, 231],
  7032: [241, 251],
  7035: [461, 471],
  7036: [481, 491],
  7037: [661, 671],
  7038: [261, 271],
  7039: [261, 271],
  7040: [281, 291],
  7041: [281, 291],
  7101: [26, 27],
  7102: [18, 19],
  7103: [161, 171],
  7104: [101, 111],
  7105: [121, 131],
  7106: [141, 151],
  7107: [381, 391],
  7108: [401, 411],
  7109: [341, 351],
  7110: [361, 371],
  7111: [321, 331],
  7201: [28, 29],
  7202: [42, 43],
  17001: [64, 64],
  17002: [59, 59],
  70241: [462, 472],
  70242: [463, 473],
  70243: [464, 474],
  70244: [464, 474],
  70261: [482, 492],
  70262: [483, 493],
  70263: [484, 494],
  70271: [662, 672],
  70272: [663, 673],
  70273: [664, 674],
  70274: [664, 674],
  70281: [702, 712],
  70282: [703, 713],
  70283: [704, 714],
  70311: [222, 232],
  70312: [223, 233],
  70321: [242, 252],
  70322: [243, 253],
  70351: [462, 472],
  70352: [463, 473],
  70361: [482, 492],
  70362: [483, 493],
  70371: [662, 672],
  70372: [663, 673],
  70381: [262, 272],
  70382: [263, 273],
  70391: [262, 272],
  70392: [263, 273],
  70401: [282, 292],
  70402: [283, 293],
  70403: [284, 294],
  70411: [282, 292],
  70412: [283, 293],
  70413: [284, 294],
  71050: [121, 131],
  71051: [121, 131],
};

/** Ids das bombas da arma (sem repetir), ou vazio se a arma não está na tabela. */
export function ballsOfWeapon(weaponTemplateId: number): number[] {
  const pair = WEAPON_BALLS[weaponTemplateId];
  return pair ? [...new Set(pair)] : [];
}
